/** Baris gilir pendaftaran pemohon, dialognya, penolakan kelulusan dan kata laluan sekali guna (pelan F3). */
export default {
  title: 'Pendaftaran pemohon',
  subtitle: 'Perunding yang memohon akaun pemohon. Setiap kelulusan menggunakan satu slot pengguna pemerhati.',
  notPermitted:
    'Hanya pentadbir penyewa, atau pegawai pelulus setelah dibenarkan oleh pentadbir, boleh menyemak pendaftaran.',
  filterLabel: 'Tapis pendaftaran',
  status: {
    submitted: 'Menunggu',
    approved: 'Diluluskan',
    rejected: 'Ditolak',
    superseded: 'Digantikan',
    expired: 'Tamat tempoh',
    all: 'Semua',
  },
  statusReason: {
    quota: 'Terlalu banyak permohonan untuk e-mel ini',
    stale: 'Tidak disemak dalam tempoh 30 hari',
  },
  columns: {
    firm: 'Firma',
    regNo: 'No. pendaftaran',
    requested: 'Dimohon',
  },
  empty: 'Tiada pendaftaran di sini.',
  total: 'Pendaftaran: {{total}}',
  approve: 'Luluskan',
  reject: 'Tolak',
  reviewed: 'Disemak oleh {{name}} pada {{date}}',
  reason: 'Sebab: {{reason}}',
  approveTitle: 'Luluskan pendaftaran ini?',
  approveBody: '{{name}} ({{email}}) akan mendapat akaun pemohon pada satu slot pengguna pemerhati.',
  cancel: 'Batal',
  approvedEmail: 'Diluluskan. Jemputan telah dihantar ke {{email}}.',
  approvedExisting: 'Diluluskan. Akaun sedia ada telah ditambah kepada pemohon.',
  approvedPassword: 'Diluluskan. Berikan kata laluan sementara kepada pemohon.',
  identityExistsGuest: 'Akaun dengan e-mel ini sudah wujud di sini sebagai pemerhati tetamu.',
  addToApplicants: 'Tambah akaun itu kepada pemohon',
  identityExistsOther:
    'Akaun dengan e-mel ini sudah wujud di sini dan bukan pemerhati tetamu, jadi ia tidak boleh menjadi pemohon. Minta orang itu mendaftar dengan e-mel lain.',
  emailInUse:
    'E-mel ini milik akaun dalam organisasi lain pada perkhidmatan ini, jadi ia tidak boleh didaftarkan di sini. Minta pemohon menggunakan e-mel lain.',
  roles: {
    admin: 'pentadbir',
    publisher: 'penerbit',
    viewer: 'pemerhati',
  },
  seatsPurchasable:
    'Semua slot {{role}} sedang digunakan ({{used}} daripada {{limit}}). Tambah slot untuk meluluskan pendaftaran ini.',
  openBilling: 'Buka Tetapan → Pengebilan',
  seatsAskAdmin:
    'Semua slot {{role}} sedang digunakan ({{used}} daripada {{limit}}). Minta pentadbir penyewa menambah slot.',
  licencePoolFull: 'Kumpulan lesen penuh: semua slot {{role}} ({{used}} daripada {{limit}}) sedang digunakan.',
  seatsOperator:
    'Semua slot {{role}} sedang digunakan ({{used}} daripada {{limit}}). Minta pengendali perkhidmatan anda menambah slot.',
  seatsBusy: 'Akaun lain sedang dicipta sekarang. Cuba lagi sebentar lagi.',
  notPending: 'Pendaftaran ini telah diputuskan. Senarai telah dimuat semula.',
  rejectTitle: 'Tolak pendaftaran ini?',
  rejectReasonLabel: 'Sebab (dilihat oleh pemohon)',
  rejectReasonRequired: 'Masukkan sebab.',
  rejected: 'Pendaftaran ditolak.',
  passwordTitle: 'Kata laluan sementara',
  passwordBody:
    'Berikan kata laluan ini kepada {{email}} melalui saluran yang anda percayai. Mereka mesti menukarnya semasa log masuk pertama.',
  passwordOnce: 'Ia dipaparkan sekali sahaja dan tidak disimpan di mana-mana. Salin sekarang.',
  copy: 'Salin',
  copied: 'Disalin',
  passwordDone: 'Saya telah menyalinnya',
} as const
